import React from 'react';

import SingleImage from "../components/Intro/SingleImage";
import Layout from "../components/Sections/Layout";
import Loader from "../components/Sections/Loader";
import Header from "../components/Sections/Header";
import Features from "../components/Sections/Features";
import Services from "../components/Sections/Services";
import Overview from "../components/Sections/Overview";
import Counters from "../components/Sections/Counters";
import Screenshots from "../components/Sections/Screenshots";
import Support from "../components/Sections/Support";
import Pricing from "../components/Sections/Pricing";
import Contact from "../components/Sections/Contact";
import Footer from "../components/Sections/Footer";
import ToTop from "../components/Sections/ToTop";
import ContactFloating from "../components/Sections/ContactFloating";
import LiveDemo from "../components/Sections/LiveDemo";
import { useI18next } from "gatsby-plugin-react-i18next";

import { graphql } from 'gatsby';

const Index = () => {
    const { t } = useI18next();
    return (
        <Layout
            pageTitle={t("pageTitle")}
            colorSchema="/colors/blue.css"
        >
            <Loader />
            <Header nav="home" />
            <SingleImage />
            |{/*<Clients className="section-box bg-grey" />*/}
            <Features />
            {/*<FeatureMatrix />*/}
            <Overview />
            <Services serviceClassName="service-single" />
            {/*<Testimonials />*/}
            <Counters />
            {/*<Team />*/}
            {/*<Subscribe />*/}
            {/*<Blog />*/}
            <Pricing className="bg-grey" />
            <Support />
            <Contact className="bg-grey" />
            <Screenshots />
            <Footer />
            <ToTop />
            <ContactFloating />
            <LiveDemo />
        </Layout>

    );
};

export default Index;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
